import {actions as userActions} from '@/store/modules/user';
import {actions as uiActions} from '@/store/modules/ui';

export const actions = {
    ...userActions,
    ...uiActions,
};
